import React from 'react';
import { TerminalLineProps, TerminalOutputProps } from '../types';
import '../styles/Terminal.css';

const TerminalLine: React.FC<TerminalLineProps> = ({ prompt, command }) => {
  return (
    <div className="terminal-line">
      <span className="terminal-prompt">{prompt}</span>
      <span className="terminal-command">{command}</span>
    </div>
  );
};

const TerminalOutput: React.FC<TerminalOutputProps> = ({ children }) => {
  return (
    <div className="terminal-output">
      {children}
    </div>
  );
};

const Terminal: React.FC = () => {
  return (
    <div className="terminal-container">
      <div className="terminal-header">
        <div className="terminal-buttons">
          <span className="terminal-button red"></span>
          <span className="terminal-button yellow"></span>
          <span className="terminal-button green"></span>
        </div>
        <span className="terminal-title">terminal</span>
      </div>
      <div className="terminal-body">
        <TerminalLine 
          prompt="user@system:~$" 
          command=" whoami" 
        />
        <TerminalOutput>
          Ryan Kennedy - Security Engineer & Developer
        </TerminalOutput>
        
        <TerminalLine 
          prompt="user@system:~$" 
          command=" cat skills.txt" 
        />
        <TerminalOutput>
          <span className="terminal-category">Security:</span> Web Exploitation, Incident Response, Log Analysis, Access Control<br />
          <span className="terminal-category">Development:</span> Python, Java, SQL, Git, Flask, Terraform
        </TerminalOutput>
        
        <TerminalLine 
          prompt="user@system:~$" 
          command=" ./start_portfolio.sh" 
        />
        <TerminalOutput>
          Initializing portfolio... Welcome!<span className="terminal-cursor"></span>
        </TerminalOutput>
      </div>
    </div>
  );
};

export default Terminal; 